export interface BarcodeOptions {
  magnification: number;
  barHeight: number;
  showText: boolean;
  showGuardExtensions: boolean;
  showQuietZones: boolean;
  dpi: number;
  lightMarginIndicator: boolean;
  cropLeft: number;
}

export const DEFAULT_OPTIONS: BarcodeOptions = {
  magnification: 100,
  barHeight: 22.85,
  showText: true,
  showGuardExtensions: true,
  showQuietZones: true,
  dpi: 600,
  lightMarginIndicator: false,
  cropLeft: 0,
};

export interface BarcodeAsset {
  _id: string;
  fileName: string;
  title: string;
  ean: string;
  dpi: number;
  magnification: number;
  previewPaths?: {
    thumbnail?: string;
    medium?: string;
  };
}

export interface GenerateResult {
  success: boolean;
  replaced: boolean;
  asset: BarcodeAsset;
  downloadUrl: string;
}

export type BatchBarcodeStatus = 'ready' | 'generated' | 'no_ean' | 'invalid' | 'error';

export interface BatchBarcodeResultItem {
  assetId: string;
  title: string;
  sourceField?: string;
  rawValue?: string;
  resolvedEan?: string;
  status: BatchBarcodeStatus;
  message?: string;
  replaced?: boolean;
  canGenerate: boolean;
  barcodeAssetId?: string;
}

export interface BatchBarcodeSummary {
  total: number;
  ready: number;
  generated: number;
  replaced: number;
  noEan: number;
  invalid: number;
  failed: number;
}

export interface BatchGenerateResponse {
  dryRun: boolean;
  summary: BatchBarcodeSummary;
  results: BatchBarcodeResultItem[];
}

export interface ProductLookupResult {
  found: boolean;
  assetId?: string;
  artikelnummer?: string;
  produktnamn?: string;
  title?: string;
}

export interface BarcodeListItem {
  _id: string;
  fileName: string;
  title: string;
  tags: string[];
  metadata: Record<string, any>;
  previewPaths?: {
    thumbnail?: string;
    medium?: string;
  };
  uploadedAt: string;
  fileSize: number;
}
